import axios from "axios";
import apiConfig from "./apiConfig";

const instance = axios.create({
  baseURL: window.env.REACT_APP_API_BASE_URL,
  headers: apiConfig().headers,
});

instance.interceptors.request.use(function (config) {
  const oktaTokenStorageString = localStorage.getItem("okta-token-storage");

  if (oktaTokenStorageString) {
    const oktaTokenStorage = JSON.parse(oktaTokenStorageString);
    const token = oktaTokenStorage.accessToken?.accessToken;
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
instance.interceptors.response.use(
  function (response) {
    // Do something with response data
    if (response.data.data) {
      return { data: response.data.data, status: response.status };
    } else {
      return response;
    }
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

export default instance;
